module.exports = __webpack_public_path__ + "static/media/waring.a62aee0d.svg";